export class ShipmentAddress {
  constructor(private _refName: string = null,
              private _address: string = null,
              private _addressLine2: string = null,
              private _zipCode: string = null,
              private _city: string = null,
              private _province: string = null,
              private _country: string = null,
  ) {
  }

  get refName(): string {
    return this._refName;
  }

  get address(): string {
    return this._address;
  }

  get addressLine2(): string {
    return this._addressLine2;
  }

  get zipCode(): string {
    return this._zipCode;
  }

  get city(): string {
    return this._city;
  }

  get province(): string {
    return this._province;
  }

  get country(): string {
    return this._country;
  }

  static fromRaw(data: any): ShipmentAddress {
    if(!data) {
      return undefined;
    }
    return new ShipmentAddress(
      data.ref_name,
      data.address,
      data.address_line_2,
      data.zip_code,
      data.city,
      data.province,
      data.country,
    );
  }

  toRaw() {
    return {
      ref_name: this._refName,
      address: this._address,
      address_line_2: this._addressLine2,
      zip_code: this._zipCode,
      city: this._city,
      province: this._province,
      country: this._country,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/shipment-address.ts